import preparedReducer from './reducer';
import { settingsInitial } from './states';
import {
  requestTeamsSettings,
  updateTeamsSettings,
} from './actions';

export const reducer = preparedReducer;

export const SLICE_NAME = 'teamsSettings';

export const selectTeamsSettings = (state) => state[SLICE_NAME]?.data || settingsInitial;

export const selectTeamsSettingsLoading = (state) => !!state[SLICE_NAME]?.loading;

export const selectTeamsSettingsLoaded = (state) => !!state[SLICE_NAME]?.loaded;

export const selectTeamsSettingsSaving = (state) => !!state[SLICE_NAME]?.saving;

export const actions = {
  requestTeamsSettings,
  updateTeamsSettings,
};
